export var TEXT_AREA_DISABLED = 'data-disabled';
export var TEXT_AREA_THEME = 'data-theme';
export var TEXT_AREA_ERROR = 'data-error';
export var TEXT_AREA_SUCCESS = 'data-success';
export var TEXT_AREA_FOCUS = 'data-focused';
//# sourceMappingURL=dataKeys.js.map